import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 41 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#222120",
  "fill-rule": "evenodd",
  d: "M40.5 11.667V30H.5V11.667zM8.833 18.333a3.335 3.335 0 0 0 0 6.667 3.335 3.335 0 0 0 .183-6.662zM40.5 0v6.667H.5V0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }